import React, { useState } from "react";
import Layout from "@/components/layout/Layout";
import Seo from "@/components/seo/Seo";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { authService } from "@/api/services";
import { toast } from "sonner";

export default function Settings() {
    const [current, setCurrent] = useState("");
    const [next, setNext] = useState("");
    const [confirm, setConfirm] = useState("");
    const [submitting, setSubmitting] = useState(false);

    const onSubmit = async (e) => {
        e.preventDefault();
        if (next !== confirm) {
            toast.error("New passwords do not match");
            return;
        }
        if (next.length < 8) {
            toast.error("Password must be at least 8 characters");
            return;
        }
        setSubmitting(true);
        try {
            await authService.changePassword(current, next);
            toast.success("Password updated");
            setCurrent("");
            setNext("");
            setConfirm("");
        } catch (err) {
            toast.error(err?.message || "Failed to update password");
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Layout>
            <Seo title="Settings" path="/settings" noIndex />
            <div className="max-w-xl mx-auto px-4 py-16">
                <div className="font-mono text-xs uppercase tracking-[0.4em] text-primary mb-3">
                    ▌ ACCOUNT
                </div>
                <h1 className="text-4xl font-black uppercase tracking-tighter mb-8">
                    Settings
                </h1>
                <form
                    onSubmit={onSubmit}
                    className="bg-card border border-border p-8 space-y-5"
                    data-testid="settings-form"
                >
                    <h2 className="text-xl font-bold tracking-tight">Change password</h2>
                    <Field
                        id="current"
                        label="Current Password"
                        value={current}
                        onChange={setCurrent}
                        testId="settings-current-password"
                    />
                    <Field
                        id="new"
                        label="New Password"
                        value={next}
                        onChange={setNext}
                        testId="settings-new-password"
                    />
                    <Field
                        id="confirm"
                        label="Confirm New Password"
                        value={confirm}
                        onChange={setConfirm}
                        testId="settings-confirm-password"
                    />
                    <Button
                        type="submit"
                        disabled={submitting}
                        className="w-full rounded-none bg-primary text-primary-foreground hover:bg-[#33FFB0] font-bold uppercase tracking-wider h-11"
                        data-testid="settings-submit-btn"
                    >
                        {submitting ? "Updating..." : "Update Password"}
                    </Button>
                </form>
            </div>
        </Layout>
    );
}

function Field({ id, label, value, onChange, testId }) {
    return (
        <div className="space-y-2">
            <Label htmlFor={id} className="font-mono text-xs uppercase tracking-widest text-zinc-400">
                {label}
            </Label>
            <Input
                id={id}
                type="password"
                required
                value={value}
                onChange={(e) => onChange(e.target.value)}
                className="rounded-none bg-background border-border focus:border-primary focus:ring-1 focus:ring-primary"
                data-testid={testId}
            />
        </div>
    );
}
